export const DEFAULT = 'default'
export const PRODUCT_PAGE = 'product-page'

export const IDLE = 'idle'
export const PENDING = 'pending'
export const FULFILLED = 'fulfilled'
export const REJECTED = 'rejected'

export const CART = 'CART'
export const OFFER = 'OFFER'
export const SAVE = 'SAVE'

// Styling related constants
export const TOOLBAR_WIDTH_DESKTOP = '410px'
export const SUMMARY_PANEL_WIDTH_DESKTOP = '525px'

// DynaMaker Integration
export const ASSEMBLY_ID = 'assembly'
